import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import Drawer from '../../../Drawer/Drawer';
import AccountGreetingOriginal from '../AccountGreeting/AccountGreeting';
import ButtonIconOriginal from '../../../Icons/ButtonIcon';
import SelectSlideOriginal from '../../../SelectSlide/SelectSlide';

export const AccountNavDialogV2 = styled(Drawer)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DialogContainer = styled.div`
  flex-grow: 1;
  width: 100%;
  padding: 0 16px;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  background-color: var(--hover);
  overflow-y: auto;
`;

export const AccountGreeting = styled(AccountGreetingOriginal)`
  ${fontTitle(20)};
  text-align: left;
  line-height: 4rem;
  padding: 0;
  margin: 0;
  margin-left: 8px;
  width: 100%;
  display: block;
`;

export const ButtonIcon = styled(ButtonIconOriginal)`
  ${fontBody(20)};
  margin-right: 8px;
`;

export const SelectSlide = styled(SelectSlideOriginal)`
  justify-content: start;
  padding: 2px;

  [aria-labelledby='accountdrawer_slideoptions'] {
    padding: 2px;
    justify-content: start;
  }
`;
